<template>
    <div class="page-wrapper">
        <ul class="menu-wrapper">
            <li class="each-menu each-menu-title">{{ parentTitle }}</li>
            <li
                class="each-menu"
                v-for="menu in subMenu"
                :key="menu.id"
                :class="menu.id == selectedMenu ? 'each-menu-active' : ''"
                @click.stop="changeMenu(menu)"
            >
                {{ menu.title }}
                <i
                    class="el-icon-arrow-right"
                    v-show="menu.id == selectedMenu"
                ></i>
            </li>
        </ul>
        <div class="content-wrapper" v-show="isListPage == 1">
            <div class="content-tille">{{ selectedMenuTitle }}</div>
            <template v-if="listData.length > 0">
                <div class="content-detail-wrapper" v-show="pageType == 4">
                    <div
                        class="each-content"
                        v-for="item in listData"
                        :key="item.id"
                        @click.stop="showDetail(item.id)"
                    >
                        <span class="each-content-title">{{ item.title }}</span>
                        <span>{{ item.create_time }}</span>
                    </div>
                </div>
            </template>
            <Pagination
                class="page"
                :totalPage="totalPage"
                :pager-count="10"
                :current-page="currentPage"
                @current-page="getCurrentPage"
                v-show="pageType == 4"
            ></Pagination>
            <div class="leadership-wrapper" v-show="pageType == 6">
                <template v-if="listData.length > 0">
                    <div
                        class="leadership"
                        v-for="item in listData"
                        :key="item.id"
                    >
                        <img :src="item.header_img" alt="image" />
                        <div class="leadership-info">
                            <div
                                class="leadership-name"
                                v-text="item.name"
                            ></div>
                            <div
                                class="leadership-position"
                                v-text="item.position"
                            ></div>
                            <div
                                class="leadership-description"
                                v-text="item.desc"
                            ></div>
                        </div>
                    </div>
                </template>
            </div>
            <div class="group-honor-wrapper" v-show="pageType == 9">
                <template v-if="listData.length > 0">
                    <div
                        class="group-honor"
                        v-for="item in listData"
                        :key="item.id"
                    >
                        <img :src="item.url" alt="image" />
                        <div class="group-honor-info">
                            <div
                                class="group-honor-time"
                                v-text="item.win_time"
                            ></div>
                            <div
                                class="group-honor-title"
                                v-text="item.title"
                            ></div>
                        </div>
                    </div>
                </template>
            </div>
            <div
                class="organizational-structure-wrapper"
                v-show="pageType == 8"
            >
                <div
                    class="organizational-title"
                    v-if="listData[0]"
                    :class="
                        listData[0] &&
                        listData[0].child &&
                        listData[0].child.length > 0
                            ? 'organizational-title-after'
                            : ''
                    "
                >
                    {{ listData[0].name }}
                </div>
                <div
                    class="organizational-children"
                    v-if="
                        listData[0] &&
                        listData[0].child &&
                        listData[0].child.length > 0
                    "
                >
                    <div
                        class="each-children"
                        :class="'each-children-' + index"
                        v-for="(item, index) in listData[0].child"
                        :key="item.id"
                        @click.stop="showOrganizationDetail(item.id)"
                    >
                        {{ item.name }}
                    </div>
                </div>
            </div>
        </div>
        <div
            class="content-wrapper content-wrapper-specail"
            v-show="isListPage == 0"
        >
            <div>
                <div
                    class="content-tille"
                    v-show="pageType != 5 && pageType != 7"
                >
                    {{ detailData.title }}
                </div>
                <div
                    class="content-tille"
                    v-show="pageType == 5 || pageType == 7"
                >
                    {{ selectedMenuTitle }}
                </div>
                <el-tabs
                    v-model="activeName"
                    @tab-click="handleClick"
                    v-show="pageType == 7"
                >
                    <el-tab-pane
                        :label="item"
                        :name="item"
                        v-for="item in timeArr"
                        :key="item"
                    ></el-tab-pane>
                </el-tabs>
                <div
                    class="content-detail-year"
                    v-show="pageType == 7"
                    v-for="item in listData"
                    :key="item.id"
                    v-html="item.message"
                ></div>
                <div class="contact-us-wrapper" v-show="pageType == 5">
                    <div
                        class="company-info"
                        v-for="item in listData"
                        :key="item.id"
                        v-show="item.slug != 'is_show_map'"
                    >
                        <div
                            class="company-name"
                            v-if="item.slug == 'contact_title'"
                        >
                            <img
                                :src="item.value"
                                v-if="item.value"
                                alt="image"
                            />
                            <span>{{ item.name }}</span>
                        </div>
                        <span v-else>{{ item.name }}：{{ item.value }}</span>
                    </div>
                    <div
                        class="map-wrapper"
                        id="map"
                        v-show="needShowMap"
                    ></div>
                </div>
                <template
                    v-show="pageType == 3 || pageType == 4 || pageType == 8"
                >
                    <div class="page-detail-wrapper">
                        <div class="pulish-time" v-show="pageType == 4">
                            发布时间: {{ detailData.created_at }}
                        </div>
                        <div
                            class="content-detail"
                            v-show="pageType == 3 || pageType == 4"
                            v-html="detailData.content"
                        ></div>
                        <div
                            class="content-detail"
                            v-show="pageType == 8"
                            v-html="detailData.desc"
                        ></div>
                    </div>
                </template>
            </div>
            <template v-if="pageType == 4 || pageType == 8">
                <div class="each-page-title-wrapper">
                    <div class="page-title-wrapper">
                        <div
                            class="each-page-tille"
                            v-if="detailData.prev_title"
                            @click.stop="changeDetail(detailData.prev_id)"
                        >
                            上一个：{{ detailData.prev_title }}
                        </div>
                        <div
                            class="each-page-tille"
                            v-if="detailData.next_title"
                            @click.stop="changeDetail(detailData.next_id)"
                        >
                            下一个：{{ detailData.next_title }}
                        </div>
                    </div>
                    <div class="back-btn" @click.stop="goBack">返回</div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import Pagination from "@/components/Pagination";
export default {
    name: "Page",
    components: {
        Pagination,
    },
    data() {
        return {
            activeName: "",
            map: "",
            needShowMap: false,
            leftMenuData: [],
            totalPage: 0,
            currentPage: 1,
            pageSize: 10,
            isListPage: sessionStorage.isListPage || 1,
            selectedMenu: 0,
            listData: [],
            timeArr: [],
            detailData: "",
        };
    },
    computed: {
        pageType() {
            let type =
                this.$store.state.subActiveTitle &&
                this.$store.state.subActiveTitle.type;
            if (sessionStorage.isListPage) {
                this.isListPage = sessionStorage.isListPage;
            } else {
                this.isListPage = type == 3 || type == 7 || type == 5 ? 0 : 1;
            }
            this.selectedMenu =
                this.$store.state.subActiveTitle &&
                this.$store.state.subActiveTitle.id;
            if (this.$route.query.detailId) {
                this.isListPage = 0;
                switch (type) {
                    case 7:
                        this.getTimesDetailData();
                        break;
                    case 8:
                        this.getOrganizationDetailData(
                            this.$route.query.detailId
                        );
                        break;
                    default:
                        this.getDetailData(this.$route.query.detailId);
                        break;
                }
            } else {
                if (type) {
                    sessionStorage.isListPage = this.isListPage;
                }
                if (sessionStorage.clickHeader) {
                    this.currentPage = 1;
                    sessionStorage.removeItem("clickHeader");
                }
                this.getListData();
            }
            return type;
        },
        parentTitle() {
            return (
                this.$store.state.activeTitle &&
                this.$store.state.activeTitle.title
            );
        },
        subMenu() {
            return (
                this.$store.state.activeTitle &&
                this.$store.state.activeTitle.children
            );
        },
        selectedMenuTitle() {
            return (
                this.$store.state.subActiveTitle &&
                this.$store.state.subActiveTitle.title
            );
        },
    },
    created() {},
    mounted() {},
    watch: {
        pageType(val) {},
    },
    methods: {
        checkIE() {
            return (
                "-ms-scroll-limit" in document.documentElement.style &&
                "-ms-ime-align" in document.documentElement.style
            );
        },
        changeDetail(id) {
            this.replaceUrlQuery("detailId", id);
            if (this.pageType == 8) {
                this.getOrganizationDetailData(id);
            } else {
                this.getDetailData(id);
            }
        },
        handleClick(tab, event) {
            this.activeName = tab.name;
            this.getTimesDetailData();
        },
        getCurrentPage(currentPage) {
            this.currentPage = currentPage;
            this.getListData();
        },
        //设置url中参数值
        setParam(param, value) {
            var query = location.search.substring(1);
            var p = new RegExp("(^|)" + param + "=([^&]*)(|$)");
            if (param) {
                if (p.test(query)) {
                    var firstParam = query.split(param)[0];
                    var secondParam = query.split(param)[1];
                    if (secondParam.indexOf("&") > -1) {
                        var lastPraam = secondParam.substring(
                            secondParam.indexOf("&") + 1
                        );
                        return (
                            "?" +
                            firstParam +
                            param +
                            "=" +
                            value +
                            "&" +
                            lastPraam
                        );
                    } else {
                        if (firstParam) {
                            return "?" + firstParam + param + "=" + value;
                        } else {
                            return "?" + param + "=" + value;
                        }
                    }
                } else {
                    if (query == "") {
                        return "?" + param + "=" + value;
                    } else {
                        return "?" + query + "&" + param + "=" + value;
                    }
                }
            } else {
                return "";
            }
        },
        replaceUrlQuery(param, value) {
            var url = window.location.href; //获取当前url
            if (url.indexOf("?") > 0) {
                url = url.split("?")[0];
            }
            window.location.replace(url + this.setParam(param, value));
        },
        showDetail(id) {
            this.isListPage = 0;
            sessionStorage.isListPage = this.isListPage;
            this.replaceUrlQuery("detailId", id);
            this.getDetailData(id);
        },
        showOrganizationDetail(id) {
            this.isListPage = 0;
            sessionStorage.isListPage = this.isListPage;
            this.replaceUrlQuery("detailId", id);
            this.getOrganizationDetailData(id);
        },
        changeMenu(menu) {
            this.resetPage(menu);
            this.currentPage = 1;
        },
        resetPage(menu) {
            this.detailData = "";
            this.isListPage =
                menu.type == 3 || menu.type == 5 || menu.type == 7 ? 0 : 1;
            this.selectedMenu = menu.id;
            sessionStorage.subActiveTitle = JSON.stringify(menu);
            this.$store.commit("subActiveTitle");
            sessionStorage.isListPage = this.isListPage;
            this.changeUrlParam(menu.id);
        },
        changeUrlParam(titleId) {
            let url = window.location.href;
            if (url.indexOf("?") > 0) {
                url = url.split("?")[0];
            }
            if (url.includes("/") > -1) {
                let arr = url.split("/");
                arr[arr.length - 1] = titleId;
                url = arr.join("/");
            }
            window.location.replace(url);
        },
        goBack() {
            this.resetPage(JSON.parse(sessionStorage.subActiveTitle));
        },
        initMap() {
            var myLatlng = new qq.maps.LatLng(40.141483, 94.658827);
            var myOptions = {
                zoom: 80, //设置地图缩放级别
                center: myLatlng, //设置中心点样式
                mapTypeId: qq.maps.MapTypeId.ROADMAP, //设置地图样式详情参见MapType
            };
            this.map = new qq.maps.Map(
                document.getElementById("map"),
                myOptions
            );
            var marker = new qq.maps.Marker({
                map: this.map,
                position: myLatlng,
            });
        },
        getListData() {
            this.$axios
                .get(
                    `${window.API.getListData}${this.selectedMenu}&pageNo=${this.currentPage}&pageSize=${this.pageSize}`
                )
                .then(({ data }) => {
                    if (data.code == 200) {
                        if (
                            data.data.type == 5 ||
                            data.data.type == 6 ||
                            data.data.type == 8 ||
                            data.data.type == 9
                        ) {
                            this.listData = data.data.lists;
                            if (data.data.type == 5) {
                                let titleName = this.listData.find(
                                    (e) => e.slug == "contact_title"
                                );
                                let titleIndex = this.listData.findIndex(
                                    (e) => e.slug == "contact_title"
                                );
                                this.listData.splice(titleIndex, 1);
                                this.listData.unshift(titleName);
                                for (let i = 0; i < this.listData.length; i++) {
                                    if (
                                        this.listData[i] &&
                                        this.listData[i].slug &&
                                        this.listData[i].slug ==
                                            "is_show_map" &&
                                        this.listData[i].value &&
                                        this.listData[i].value == 1
                                    ) {
                                        this.needShowMap = true;
                                        this.initMap();
                                    }
                                }
                            }
                        } else if (data.data.type == 4) {
                            this.listData = data.data.article;
                            this.totalPage = data.data.totalPage;
                            this.currentPage = data.data.currentPage;
                        } else if (data.data.type == 7) {
                            this.listData = data.data.lists;
                            this.timeArr = data.data.timeArr;
                            this.activeName = this.timeArr[0];
                        } else if (data.data.type == 3) {
                            this.detailData = data.data.article;
                        }
                    }
                })
                .catch();
        },
        getDetailData(id) {
            this.$axios
                .get(
                    `${window.API.getDetailData}${id}&pageNo=${this.currentPage}&pageSize=${this.pageSize}`
                )
                .then(({ data }) => {
                    if (data.code == 200) {
                        this.detailData = data.data;
                    }
                })
                .catch();
        },
        getOrganizationDetailData(id) {
            this.$axios
                .get(`${window.API.getOrganizationDetailData}${id}`)
                .then(({ data }) => {
                    if (data.code == 200) {
                        this.detailData = data.data;
                    }
                })
                .catch();
        },
        getTimesDetailData() {
            this.$axios
                .get(
                    `${window.API.getTimesDetailData}${this.selectedMenu}&time=${this.activeName}&pageNo=${this.currentPage}&pageSize=${this.pageSize}`
                )
                .then(({ data }) => {
                    if (data.code == 200) {
                        this.listData = data.data.lists;
                    }
                })
                .catch();
        },
    },
};
</script>
<style lang="scss" scoped>
.page-wrapper/deep/ {
    min-height: calc(100% - 300px);
    .map-wrapper {
        margin-top: 40px;
        width: 925px;
        height: 295px;
    }
    width: 1200px;
    margin: 0 auto;
    display: flex;
    .el-tabs__item.is-active {
        color: #58bca5;
    }
    .el-tabs__active-bar {
        background-color: #58bca5;
    }
    .el-tabs__item {
        color: #8f8f8f;
    }
    .menu-wrapper {
        .each-menu {
            margin-bottom: 2px;
            position: relative;
            width: 200px;
            height: 42px;
            line-height: 42px;
            text-align: center;
            background: #dcdcdc;
            font-size: 14px;
            font-weight: 400;
            color: #4b4b4b;
            cursor: pointer;
        }
        .el-icon-arrow-right {
            top: 15px;
            position: absolute;
            right: 9px;
        }
        .each-menu-active {
            background: #58bca5;
            color: #ffffff;
            font-weight: 600;
        }
        .each-menu-title {
            margin-bottom: 2px;
            background: url("../assets/menu-left-bg.png") center center
                no-repeat;
            background-size: 100%;
            border-radius: 14px 14px 0px 0px;
            font-size: 16px;
            color: #ffffff;
            font-weight: 600;
            cursor: default;
        }
    }
    .content-wrapper-specail {
        padding-right: 50px !important;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    .content-wrapper {
        margin-left: 14px;
        width: 986px;
        min-height: calc(100vh - 300px);
        padding: 10px 30px 20px 18px;
        box-sizing: border-box;
        background: #ffffff;
        .content-tille {
            margin-bottom: 4px;
            font-size: 20px;
            font-weight: 600;
            color: #464646;
            line-height: 28px;
            background: url("../assets/menu-border-bg.png") left center
                no-repeat;
            background-size: 6px 18px;
            text-indent: 24px;
        }
        .content-detail-year {
            margin-bottom: 28px;
            p {
                display: inline;
            }
        }
        .each-content {
            position: relative;
            display: flex;
            justify-content: space-between;
            padding-left: 10px;
            font-size: 14px;
            color: #000000;
            line-height: 52px;
            border-bottom: 1px solid #e1e1e1;
            &:hover span {
                color: #58bca5;
                font-weight: 600;
            }
            cursor: pointer;
            &::before {
                position: absolute;
                top: 23px;
                left: 0;
                content: "";
                display: inline-block;
                width: 6px;
                height: 6px;
                background: #58bca5;
                border-radius: 50%;
            }
        }
        .each-content-title {
            width: 835px;
            padding-right: 10px;
        }
    }
    .page-detail-wrapper {
        .pulish-time {
            margin-bottom: 16px;
            padding-left: 24px;
            font-size: 14px;
            font-weight: 400;
            color: #626262;
            line-height: 20px;
        }
        .content-detail {
            width: 887px;
            margin-left: 24px;
            box-sizing: border-box;
            padding-bottom: 35px;
            margin-bottom: 4px;
            font-size: 14px;
            font-weight: 400;
            color: #444444;
            line-height: 23px;
        }
    }
    .each-page-tille {
        margin-top: 10px;
        font-size: 14px;
        color: #464646;
        line-height: 20px;
        cursor: pointer;
    }
    .each-page-tille:hover {
        color: #58bca5;
    }
    .each-page-tille-active {
        color: #58bca5;
    }
    .each-page-title-wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 24px;
        padding-top: 10px;
        border-top: 1px solid #d7d7d7;
        .back-btn {
            width: 132px;
            height: 40px;
            background: url("../assets/home-more.png") center center no-repeat;
            background-size: 100%;
            font-size: 18px;
            font-weight: 600;
            color: #58bca5;
            line-height: 40px;
            text-align: center;
            cursor: pointer;
        }
    }
    .leadership-wrapper {
        img {
            width: 150px;
            height: 210px;
        }
        .leadership {
            display: flex;
            padding: 30px 0 30px 32px;
        }
        .leadership-info {
            margin-left: 34px;
            width: 702px;
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            line-height: 23px;
        }
        .leadership-name {
            margin: 16px 0 17px;
            font-size: 18px;
            font-weight: 600;
            color: #464646;
        }
        .leadership-description {
            margin-top: 14px;
        }
    }
    .group-honor-wrapper {
        display: flex;
        justify-content: space-between;
        padding-right: 15px;
        flex-wrap: wrap;
        img {
            display: block;
            width: 246px;
            height: 160px;
            border: 6px solid #490000;
        }
        .group-honor {
            margin-left: 37px;
            margin-top: 44px;
            width: 247px;
        }
        .group-honor-info {
            display: flex;
            justify-content: space-between;
            margin-top: 20px;
            font-size: 14px;
            font-weight: 400;
            color: #999999;
            line-height: 23px;
        }
        .group-honor-title {
            width: 182px;
        }
    }
    .organizational-structure-wrapper {
        display: flex;
        margin-left: 190px;
        .organizational-title {
            position: relative;
            margin-top: 215px;
            width: 50px;
            height: 310px;
            padding: 30px 14px;
            box-sizing: border-box;
            background: rgba(88, 188, 165, 0.1);
            border-radius: 4px;
            border: 1px solid #58bca5;
            font-size: 18px;
            color: #58bca5;
            line-height: 25px;
        }
        .organizational-title-after::after {
            position: absolute;
            top: 165px;
            left: 49px;
            content: "";
            display: inline-block;
            width: 46px;
            height: 1px;
            background: #58bca5;
        }
        .organizational-children {
            position: relative;
            margin-left: 45px;
            margin-top: 77px;
            padding-left: 73px;
        }
        .organizational-children::before {
            position: absolute;
            top: 24px;
            left: 1px;
            content: "";
            display: inline-block;
            width: 1px;
            height: 561px;
            background: #58bca5;
        }
        .each-children {
            position: relative;
            margin-bottom: 20px;
            width: 407px;
            height: 50px;
            background: rgba(88, 188, 165, 0.1);
            border-radius: 4px;
            border: 1px solid #58bca5;
            font-size: 18px;
            color: #58bca5;
            line-height: 50px;
            text-indent: 20px;
            cursor: pointer;
        }
        .each-children-8 {
            border: 1px dashed #58bca5;
        }
        .each-children-0::before,
        .each-children-1::before,
        .each-children-2::before,
        .each-children-3::before,
        .each-children-4::before,
        .each-children-5::before,
        .each-children-6::before,
        .each-children-7::before,
        .each-children-8::before {
            position: absolute;
            content: "";
            top: 23px;
            left: -72px;
            display: inline-block;
            width: 72px;
            height: 1px;
            background: #58bca5;
        }

        .each-children:hover {
            background: #58bca5;
            color: #ffffff;
        }
    }
    .contact-us-wrapper {
        padding-left: 14px;
        .company-name span {
            font-size: 16px;
            font-weight: 600;
            color: #464646;
            line-height: 22px;
        }
        .company-name {
            display: flex;
            align-items: center;
            margin-top: 20px;
            img {
                margin-right: 2px;
                width: 14px;
                height: 18px;
            }
        }
        .company-info {
            margin-top: 20px;
            font-size: 14px;
            font-weight: 600;
            color: #464646;
            line-height: 20px;
        }
    }
}
</style>